import React from 'react';

/**
 * Loading indicator
 */
export const Loader: React.FC = () => {
  return (
    <div className="loading-container">
      <div className="loading"></div>
    </div>
  );
};
